import axios from 'axios';

import type { ExposureModel, ExposureTotalsModel } from '../types/exposure-types';

export function getExposuresUrl(claim_id: number): string {
  return `/api/v1/claims/${claim_id}/exposures_and_total_amounts`;
}

export interface ExposuresAndTotalAmountsData {
  exposures: ExposureModel[];
  exposures_totals?: ExposureTotalsModel;
}

export const fetchExposuresAndTotalAmounts = async (claim_id: number): Promise<ExposuresAndTotalAmountsData> => {
  const response = await axios.get(getExposuresUrl(claim_id));
  return response.data;
};

export const closeExposure = async (
  claim_id: number,
  exposure_id: number,
  reason: string,
  extra: string | null = null
) => {
  await axios.post(`/api/v1/claims/${claim_id}/exposures/${exposure_id}/close`, {
    reason,
    extra,
  });
};
